import { FunctionComponent } from 'react';

export const NotFound: FunctionComponent = () => {
  return <div>404 - Page non trouvé</div>;
};
